export interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
  hoverable?: boolean;
  noPadding?: boolean;
}

export const Card = ({
  children,
  className = '',
  title,
  subtitle,
  footer,
  hoverable = false,
  noPadding = false,
}: CardProps) => {
  return (
    <div
      className={`rounded-lg border border-gray-200 bg-white shadow-md dark:border-dark-700 dark:bg-dark-800 ${
        hoverable ? 'transition-shadow duration-200 hover:shadow-lg' : ''
      } ${className}`}
    >
      {(title || subtitle) && (
        <div className="px-6 pb-4 pt-6">
          {title && (
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h2>
          )}
          {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
        </div>
      )}
      <div
        className={`text-gray-700 dark:text-gray-300 ${
          noPadding ? '' : title || subtitle ? 'px-6 pb-6' : 'p-6'
        }`}
      >
        {children}
      </div>
      {footer && (
        <div className="border-t border-gray-200 px-6 pb-6 pt-4 dark:border-dark-700">{footer}</div>
      )}
    </div>
  );
};
